<div class="navaid">
  <div class="navaid__main">
    <div class="navaid__header">{{ navaid.identifier }} - {{ navaid.name }}</div>
    <div class="navaid__frequency">Frequency: {{ navaid.frequency }}</div>
    <div class="navaid__location">{{ navaid.location.format('FFf', { decimalPlaces: 1, latLonSeparator: ', ' }) }}</div>
    <div class="navaid__bearing">
      <div class="navaid__bearing-label">{{ navaid.identifier }} to airport:</div>
      <div class="navaid__bearing-value">
        <app-bearing [bearing]="navaid.radial" [color]="'#537171'" class="navaid__bearing-indicator"></app-bearing>
        {{ bearing }}&deg; |
        {{ navaid.distance | number: '1.1-1' }} nm
      </div>
    </div>
  </div>
  <div class="navaid__icon-container">
    <mat-icon *ngIf="icon" [svgIcon]="icon" [matTooltip]="type" class="navaid__icon"></mat-icon>
  </div>
  <span class="icons-container">
    <mat-icon (click)="openEditNavaidDialog(navaid)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="edit-icon" mat-tooltip="Edit Navaid" aria-label="Button that opens popover that allows you to edit navaids">edit</mat-icon>
    <mat-icon (click)="deleteNavaid(navaid)" *ngIf="editModeSet && isFlightDeckAdmin && isIslandSource" class="delete-icon" mat-tooltip="Delete Navaid" aria-label="Button deletes navaid">delete_outline</mat-icon>
  </span>
</div>
